import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { TechDocsFeedbackAddon as TechDocsFeedbackAddonComponent } from './components/TechDocsFeedbackAddon';

/**
 * The custom entity feedback plugin
 *
 * @public
 */
export const customEntityFeedbackPlugin = createPlugin({
  id: 'custom-entity-feedback',
});

/**
 * TechDocs addon that allows users to provide feedback on documentation
 *
 * @public
 */
export const TechDocsFeedbackAddon = customEntityFeedbackPlugin.provide(
  createTechDocsAddonExtension({
    name: 'TechDocsFeedbackAddon',
    location: TechDocsAddonLocations.Content,
    component: TechDocsFeedbackAddonComponent,
  }),
);